/*
  Produktvideos in der Galerie automatisch abspielen (leonid matthias, 11.10.2026).
  - Sobald ein Video-Slide ausgewählt ist (Pfeil, Wischen, Vorschaubild), startet
    das Video stumm; Browser erlauben Autoplay nur ohne Ton. Wer per Regler den Ton
    einschaltet, behält ihn für dieses Video.
  - Andere Videos der Galerie halten an.
  - Läuft ein Video, pausiert die automatische Bilder-Diashow, danach geht sie weiter.
  Grund: Der Theme-Code pausiert beim Slide-Wechsel alle Videos, auch das gerade
  ausgewählte, deshalb lief bisher nichts von selbst.
*/
(function () {
  'use strict';

  function videosIn(galerie) {
    return Array.prototype.slice.call(galerie.querySelectorAll('[data-html5-video] video'));
  }

  function stumm(video) {
    if (video.dataset.lmTon !== '1') video.muted = true;
  }

  function abspielen(galerie) {
    var flkty = window.Flickity && window.Flickity.data(galerie);
    if (!flkty || !flkty.selectedElement) return;
    var auswahl = flkty.selectedElement;

    videosIn(galerie).forEach(function (video) {
      if (!auswahl.contains(video) && !video.paused) video.pause();
    });

    var video = auswahl.querySelector('[data-html5-video] video');
    if (video) {
      stumm(video);
      var versuch = video.play();
      if (versuch && versuch.catch) {
        versuch.catch(function () {
          video.muted = true;
          video.play().catch(function () {});
        });
      }
      if (flkty.player && flkty.player.state === 'playing') flkty.pausePlayer();
    } else if (flkty.player && flkty.player.state === 'paused') {
      flkty.unpausePlayer();
    }
  }

  function einrichten(galerie) {
    if (galerie.dataset.lmAutoplay === '1') return true;
    var flkty = window.Flickity && window.Flickity.data(galerie);
    if (!flkty) return false;
    galerie.dataset.lmAutoplay = '1';

    videosIn(galerie).forEach(function (video) {
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      stumm(video);
      video.addEventListener('volumechange', function () {
        var aktiv = navigator.userActivation ? navigator.userActivation.isActive : false;
        if (!video.muted && aktiv) video.dataset.lmTon = '1';
      });
    });

    // Nach den Theme-Handlern laufen (die pausieren beim Wechsel alle Videos).
    var spaeter = function () { setTimeout(function () { abspielen(galerie); }, 0); };
    flkty.on('change', spaeter);
    flkty.on('settle', spaeter);
    spaeter();
    return true;
  }

  function alleEinrichten() {
    var offen = false;
    document.querySelectorAll('[data-product-gallery]').forEach(function (galerie) {
      if (!galerie.querySelector('[data-html5-video]')) return;
      if (!einrichten(galerie)) offen = true;
    });
    return offen;
  }

  // Flickity lädt das Theme nachträglich; deshalb kurz nachfassen.
  var runden = 0;
  var takt = setInterval(function () {
    runden += 1;
    if (!alleEinrichten() || runden > 60) clearInterval(takt);
  }, 250);
})();
